import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#time-picker" }),
    /*#__PURE__*/_createTextVNode(" TimePicker ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Use Time Picker for time input. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUIArbitraryTimePicker = _resolveComponent("EUIArbitraryTimePicker")
  const _component_EUIArbitraryTimeRange = _resolveComponent("EUIArbitraryTimeRange")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUIArbitraryTimePicker),
    _createVNode(_component_EUIArbitraryTimeRange)
  ], 64))
}